<template>
  <table class="table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="min-width">№</th>
        <th scope="col" class="min-width">Player</th>
        <th scope="col" class="min-width">Score</th>
        <th scope="col">Details</th>
      </tr>
    </thead>
    <tr
      v-for="(record, index) in rating"
      :key="record.entityId"
    >
      <td class="num">
        {{index + 1 | getFormattedNumber}}
      </td>
      <td>
        <player-link :playerId="record.entityId" lable="player" />
      </td>
      <td class="num">
        {{record.score | getFormattedNumber}}
      </td>
      <td>
        <contest-player-link :contestPlayerId="createContestPlayerId(record.entityId)">
          player {{record.entityId}} as contest member
        </contest-player-link>
      </td>
    </tr>
  </table>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';
import ContestPlayerLink from '../ContestPlayerLink.vue';

export default {
  name: 'PlayerHistoryRating',

  components: {
    PlayerLink,
    ContestPlayerLink,
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },

    rating: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /** @param {number} playerId */
    createContestPlayerId(playerId) {
      return {
        contestId: this.contestId,
        playerId: playerId,
      };
    },
  },
};
</script>

<style scoped>
.num {
  text-align: right;
}

.min-width {
  width: 1px;
}
</style>
